if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        /* ========================================
           CORREÇÃO CYGNUSS - VERIFICAÇÃO DE NULL
           Função: Prevenir erro de parentElement null
           Data: Junho 2025
        ======================================== */
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        
        // Verificar se activeMedia existe antes de prosseguir
        if (!activeMedia) {
          console.warn(`Media element with ID "${mediaId}" not found`);
          return;
        }
        
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        /* Self-heal Cygnuss progressive lazy-load (main-product.liquid deferDistantSlides):
           Se a slide ativa tem img.cy-deferred (src=placeholder 1x1), restaura src/srcset originais
           armazenados em data-cy-src/data-cy-srcset. Workaround pra cadeia aria-current→preloadAhead
           que falha intermitentemente em variant changes pra slides distantes. */
        const deferredImg = activeMedia.querySelector('img.cy-deferred');
        if (deferredImg) {
          const dsSrcset = deferredImg.getAttribute('data-cy-srcset');
          const dsSrc = deferredImg.getAttribute('data-cy-src');
          if (dsSrcset) deferredImg.setAttribute('srcset', dsSrcset);
          if (dsSrc) deferredImg.src = dsSrc;
          deferredImg.classList.remove('cy-deferred');
        }

        if (prepend) {
          // Verificar se activeMedia tem parentElement antes de usar
          if (activeMedia && activeMedia.parentElement) {
            activeMedia.parentElement.prepend(activeMedia);
          }
          
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            // Verificar se activeThumbnail existe e tem parentElement
            if (activeThumbnail && activeThumbnail.parentElement) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        // Cygnuss 2026-05-28 (Fase 7 — Bug #10): cancela setTimeout anterior se
        // user clicar outro thumb antes do scroll terminar. Sem isso, dois
        // scrollTo concorrentes brigavam no smooth-scroll e travavam thumbnail
        // strip no meio do caminho.
        if (this._cygScrollTimeout) clearTimeout(this._cygScrollTimeout);
        this._cygScrollTimeout = window.setTimeout(() => {
          this._cygScrollTimeout = null;
          if (this.elements.thumbnails) {
            // Verificar se activeMedia e parentElement existem antes de scrollTo
            if (activeMedia && activeMedia.parentElement) {
              activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
            }
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            // Verificar se activeMedia existe antes de scrollIntoView
            if (activeMedia) {
              activeMedia.scrollIntoView({ behavior: 'smooth' });
            }
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        
        // Verificar se activeThumbnail existe antes de acessar dataset
        if (activeThumbnail && activeThumbnail.dataset) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        
        // Verificar se thumbnail tem querySelector antes de usar
        const thumbnailButton = thumbnail.querySelector('button');
        if (thumbnailButton) {
          thumbnailButton.setAttribute('aria-current', true);
        }
        
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        // Verificar se activeItem existe antes de prosseguir
        if (!activeItem) return;
        
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
      //  window.pauseAllMedia();
        // Verificar se activeItem existe antes de prosseguir
        if (!activeItem) return;
        
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

